export const PRIMARY_TITLE = "Tim James";

export const TITLE_SEPARATOR = " | ";

export const DEFAULT_SUB_TITLE = "Full-Stack Software Engineer 🚀";

export const DEFAULT_DESCRIPTION =
  "Hi, I'm Tim William James, a full-stack developer from Canberra, Australia" +
  ". My core technologies include TypeScript, React, Tailwind, AWS, and " +
  "ForgeRock.";
